
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d3c25ee4\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./Circle10.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Circle10.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d3c25ee4\"}!../../../vue-loader/lib/selector?type=template&index=0!./Circle10.vue"),
  /* scopeId */
  "data-v-d3c25ee4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/Circle10.vue
// module id = 811
// module chunks = 170